<template>
    <div style="width: 100%">
        <vue-cal class="vuecal--full-height-delete"
                editable-events
                :time-step="15"
                :on-event-create="onEventCreate"
        >
        </vue-cal>

        <v-dialog v-model="showEventCreationDialog" :persistent="true" max-width="420">
            <v-card>
                <v-card-title>
                    <v-text-field
                            outlined
                            v-model="selectedEvent.title"
                            label="Event Title"
                            placeholder="Title"/>
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xl5>
                            <v-text-field
                                    outlined
                                    v-model="selectedEvent.startTime"
                                    label="Start Time"
                                    placeholder="start"/>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xl5>
                            <v-text-field
                                    outlined
                                    v-model="selectedEvent.endTime"
                                    label="End Time"
                                    placeholder="end"/>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <v-textarea
                                    label="Event Content"
                                    v-model="selectedEvent.content"
                                    placeholder="Content"/>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <v-select
                                    :items="eventsCssClasses"
                                    placeholder="Select Clients"
                                    @change="selectedEvent.classes = [$event]"/>
                            <!-- TODO add attachment notes and form notes -->
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <v-btn @click="cancelEventCreation()">Cancel</v-btn>
                            <v-btn color="primary" @click="closeCreationDialog()">Save</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'

    export default {
        name: "Calendar",
        components: { VueCal },
        data: () => ({
            selectedEvent: {},
            start: "",
            end: "",
            showEventCreationDialog: true,
            eventsCssClasses: ['leisure', 'sport', 'health']
        }),
        methods: {
            onEventCreate (event, deleteEventFunction) {
                console.log('event: ', event);

                this.selectedEvent = event;
                this.showEventCreationDialog = true;
                //this.deleteEventFunction = deleteEventFunction;
                return event
            },
            cancelEventCreation () {
                this.closeCreationDialog();
           //     this.deleteEventFunction();
            },
            closeCreationDialog () {
                this.showEventCreationDialog = false
                this.selectedEvent = {}
            }
        }
    }
</script>

<style scoped>

</style>